import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard/dashboard.component';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from "../../shared/shared.module"
import { MatTooltipModule } from '@angular/material/tooltip';
import { SwiperModule } from "swiper/angular";
import { ImagesLazyloadModule } from 'src/app/shared/images-lazyload.module';


const routes: Routes = [{
  path: "",
  component: DashboardComponent,
  
},]


@NgModule({
  declarations: [DashboardComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    MatTooltipModule,
    SwiperModule,
    ImagesLazyloadModule
  ]
})
export class DashboardModule { }
